import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { KeyWord } from 'src/app/shared/classes/constants';
import { ThemingService } from 'src/app/shared/services/theming.service';
import { KeywordData } from '../../shared/classes/keywordData';

@Component({
  selector: 'app-list-keyword-details',
  templateUrl: './list-keyword-details.component.html',
  styleUrls: ['./list-keyword-details.component.scss']
})
export class ListKeywordDetailsComponent implements OnInit {

  masterSelected!: boolean;
  paginateData: KeywordData[] = [];
  checked: boolean = false;
  keyWordData: KeywordData[] = [];
  page: number = 1;
  count: number = 4;
  tableSize: number = 15;
  totalData: string = "0";
  statusArray = KeyWord.statusArray;
  labelArray = KeyWord.labelArray;
  isAllChecked: boolean = false;
  tagArray: string[] = [];
  isAllTagsShowed: boolean = false;
  @ViewChild('menuTrigger') trigger: any;
  @ViewChild('menuTrigger1') trigger1: any;
  index: number = 0;
  status: string = "All";
  isDisable: boolean = true;
  tableHeading = [
    "Tag","Keyword","Status","Vol","F.","W3","CPC","Serp analyst"
  ]

  theme: boolean = true;

  get menu() {
    return !this.theme ? 'providers-menu' : ''
  }

  get selectMenu() {
    return !this.theme ? 'testClass' : ''
  }

  get popover() {
    return !this.theme ? 'dark-popover' : ''
  }

  constructor(
    private router: Router,
    private themingService: ThemingService,
    private modal:NgbModal
  ) {
    this.themingService.nameKeeper.subscribe(val => this.theme = val)
  }

  ngOnInit(): void {
    this.getData();
    this.onTableDataChange();
  }
  getData() {
    for (let i = 0; i < 1107; i++) {
      const data =
      {
        "label": this.getMultipleRandom(this.labelArray, this.getRandomInt(1, 6)),
        "title": "Which is better between kito diet and intermittent fasting",
        "status": this.statusArray[Math.floor(Math.random() * this.statusArray.length)],
        "Volume": "14",
        "serpAnalysis": [
          {
            "img": "../../assets/images/Serp logo.svg",
            "number": "1",
            "desc": "serp"
          },
          {
            "img": "../../assets/images/comments-alt.svg",
            "number": "2",
            "desc": "comments"
          },
          {
            "class": "rounded no-image rounded",
            "number": "3",
            "desc": "noImg"
          },
          {
            "img": "../../assets/images/Vector.svg",
            "number": "4",
            "desc": "vector"
          },
          {
            "img": "../../assets/images/Serp logo.svg",
            "number": "5",
            "desc": "serp"
          },
          {
            "img": "../../assets/images/Vector.svg",
            "number": "6",
            "desc": "vector"
          },
          {
            "class": "border rounded-circle color-image",
            "number": "7",
            "desc": "colorImg"
          },
          {
            "img": "../../assets/images/Vector.svg",
            "number": "8",
            "desc": "vector"
          },
          {
            "class": "border rounded-circle color-image",
            "number": "9",
            "desc": "colorImg"
          },
          {
            "img": "../../assets/images/comments-alt.svg",
            "number": "10",
            "desc": "comments"
          }
        ],
        "CPC": "$19.36",
        "isChecked": false
      }
      this.keyWordData.push(data);
      this.paginateData.push(data);
    }
  }
  getRandomInt(min: number, max: number) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  getMultipleRandom(arr: any, num: number) {
    const shuffled = [...arr].sort(() => 0.5 - Math.random());

    return shuffled.slice(0, num);
  }

  CheckAll() {
    for (let i = 0; i < this.keyWordData.length; i++) {
      if (this.status == "All") {
        this.keyWordData[i].isChecked = this.masterSelected
      } else {
        if (this.status === this.keyWordData[i].status) {
          this.keyWordData[i].isChecked = this.masterSelected
        }
      }
    }
  }
  isAllSelected(index: number) {
    this.index = index
    this.masterSelected = this.keyWordData.every((item: any) => {
      return item.isChecked == true;
    });
  }

  buttonState() {
    return !this.keyWordData.some(_ => _.isChecked);
  }
  openModal(content:any){
    this.modal.open(content, { centered: true, windowClass: !this.theme ? 'dark-modal' : '' });
  }
  onTableDataChange() {
    const lastIndex = this.page * 15;
    const firstIndex = lastIndex + 1 - 15
    const pageCount = this.keyWordData.length / this.tableSize;
    this.count = Math.ceil(pageCount);
    if (this.page == this.count) {
      this.totalData = firstIndex + "-" + this.keyWordData.length
    }
    else {
      this.totalData = firstIndex + "-" + lastIndex
    }
    this.paginateData = this.keyWordData
      .slice((this.page - 1) * this.tableSize, (this.page - 1) * this.tableSize + this.tableSize);
  }
  checkCheckBoxvalue(event: any) {
    if (event.target.checked) {
      this.tagArray.push(event.target.defaultValue)
      this.tagArray = this.tagArray.filter(function (item, pos, self) {
        return self.indexOf(item) == pos;
      });
    }
  }
  onApply(arg: string) {
    if (arg === 'Add tags') {
      this.keyWordData.forEach(e => {
        if (e.isChecked) {
          let arr = [...e.label, ...this.tagArray];
          let uniqueArr = [...new Set(arr)];
          e.label = [...uniqueArr];
        }
      })
      this.trigger.closeMenu();
    } else if (arg === 'Move to list') {
      this.trigger1.closeMenu();
    } else {
      this.trigger.closeMenu();
    }

  }
  onCancel() {
    this.trigger.closeMenu();
  }
  markComplete() {
    this.keyWordData.forEach(e => {
      if (e.isChecked && e.status == "Not Completed") {
        e.status = "Completed"
      }
    })
  }
  onDelete() {
    let check = this.keyWordData.every(v => v.isChecked === true);
    if (check && this.status == "All") {
      this.keyWordData.length = 0
      this.onTableDataChange();
      this.masterSelected = false;
    } else if (check && (this.status == "Completed" || this.status == "Not Completed") && this.keyWordData.length > 0) {
      this.keyWordData.splice(0, this.keyWordData.length);
      this.onTableDataChange();
      this.masterSelected = false;
    }
    else {
      this.keyWordData.forEach((e, index) => {
        if (e.isChecked && (this.status)) {
          this.keyWordData.splice(index, 1);
          this.onTableDataChange();
          this.masterSelected = false;
        }
      })
    }
    this.modal.dismissAll();
  }
  goBackToParent() {
    this.router.navigate(['lckr/list'])
  }
  filterByStatus() {
    if ((this.status === "Completed" || this.status === "Not Completed")) {
      this.keyWordData = this.keyWordData.filter(e => e.status === this.status);
      this.masterSelected = false;
      if (this.keyWordData.length == 0) {
        this.getData();
        this.keyWordData = this.keyWordData.filter(e => e.status === this.status);
      }
      this.CheckAll();
      this.onTableDataChange();
    } else if (this.status === "All") {
      this.keyWordData.length = 0;
      this.getData();
      this.masterSelected = false;
      this.CheckAll();
      this.onTableDataChange();
    }
  }
}
